import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, IconButton } from '@mui/material';
import { useBannerMessageContext } from '../context/banner-message';
import { Warning } from '@mui/icons-material';

/**
 * Dashboard banner component that displays admin messages at the bottom of the screen.
 * The banner can be dismissed by clicking the close button.
 */
export function DashboardBanner() {
  const { bannerMessage, setDismissed } = useBannerMessageContext();

  if (!bannerMessage) {
    return null;
  }

  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        right: 0,
      }}
    >
      <Alert
        icon={false}
        severity="warning"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setDismissed(true)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{
          width: '100%',
          '& .MuiAlert-message': {
            width: '100%',
            textAlign: 'center',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Warning fontSize="small" sx={{ mr: 1 }} /> {bannerMessage}
        </Box>
      </Alert>
    </Box>
  );
}
